import Vue from 'vue'
import { Button, Input, Select, Option, Form, FormItem, DatePicker, Dialog, Slider, Icon, InputNumber, Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Button)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Slider)
Vue.use(Icon)
Vue.use(InputNumber)

Vue.prototype.$message = Message
